<template>
	<AppLayout :title="trans('meetings.title')" :subtitle="trans('meetings.subtitle')">
		<Alert :color="Color.Blue">{{ trans('meetings.info') }}</Alert>
		<Alert :color="Color.Yellow">{{ trans('meetings.warning') }}</Alert>
		<div class="flex flex-col items-start gap-3">
			<LabeledObject>
				<template #label>{{ trans('meetings.layouts.title') }}</template>
				<select v-model="layout">
					<option v-for="selectedLayout in CalComLayout" :value="selectedLayout">{{ trans(`meetings.layouts.${selectedLayout}`) }}</option>
				</select>
			</LabeledObject>
			<div :id="calId" class="w-full overflow-scroll"/>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import {initCalCom} from '@/cal'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import AppLayout from '@/Layouts/AppLayout.vue'
import Alert from '@/Components/UI/Alerts/Alert.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {CalComLayout} from '@/Types/Meetings/CalComLayout'
import {defineProps, onMounted, type Ref, ref, watch} from 'vue'

const props = defineProps<{
	namespace:string,
}>()

const namespace:Ref<string> = ref(props.namespace)
const layout:Ref<CalComLayout> = ref(CalComLayout.Monthly)
const calId:Ref<string> = ref(`inline-cal-sysadmin-${namespace.value}`)

watch(layout, (value:CalComLayout) => {
	initCalCom(namespace.value, calId.value, value)
})

onMounted(() => {
	initCalCom(namespace.value, calId.value, layout.value)
})
</script>